export const loginLoader = ({store}) => store.loginReducer.loading;
export const loginData = ({store}) => store.loginReducer.data;
export const loginError = ({store}) => store.loginReducer.error;
export const loginStatus = ({store}) => store.loginReducer.status;

export const signupLoader = ({store}) => store.signupReducer.loading;
export const signupData = ({store}) => store.signupReducer.data;
export const signupError = ({store}) => store.signupReducer.error;
export const signupStatus = ({store}) => store.signupReducer.status;